import React from 'react';

const AdminGhostingContext = React.createContext();

export function AdminGhostingProvider({ children }) {
  const [adminGhostingSellerId, setAdminGhostingSellerId] = React.useState(null);

  const value = React.useMemo(
    () => ({
      adminGhostingSellerId,
      setAdminGhostingSellerId,
    }),
    [adminGhostingSellerId],
  );

  return <AdminGhostingContext.Provider value={value}>{children}</AdminGhostingContext.Provider>;
}

export function useAdminGhosting() {
  const context = React.useContext(AdminGhostingContext);
  if (context === undefined) {
    throw new Error('useAdminGhosting must be used within a AdminGhostingProvider');
  }
  return context;
}
